module.exports = __webpack_public_path__ + "img/bg-compliance-3.be6dff21.png";